import { SignInWithRedirectInput, signInWithRedirect } from 'aws-amplify/auth';

const attemptSignInWithRedirect = ({ provider, customState }: SignInWithRedirectInput) =>
  signInWithRedirect({ provider, customState });

const authSignInWithRedirect = ({ provider, customState }: SignInWithRedirectInput) =>
  attemptSignInWithRedirect({ provider, customState });

export default authSignInWithRedirect;
